const FILTER_SETTLE_DELAY = 200;

const initializedPages = new WeakSet();

const place = (page, card, pinned) => {
    const grid = pinned
        ? page.querySelector('[data-pinned-grid]')
        : page.querySelector(`[data-home-grid="${card.dataset.toolScope}"]`)
    ;
    const order = Number(card.dataset.order);
    let before = null;

    grid.querySelectorAll('.card').forEach(other => {
        if (before === null && Number(other.dataset.order) > order) {
            before = other;
        }
    });

    grid.insertBefore(card, before);
};

const updatePinnedSection = (page) => {
    const grid = page.querySelector('[data-pinned-grid]');
    const section = page.querySelector('[data-pinned-section]');
    const cards = Array.from(grid.querySelectorAll('.card'));
    const anyVisible = cards.some(card => card.style.display !== 'none');

    section.hidden = !anyVisible;
};

const applyPinState = (button, card, page, pinned) => {
    button.setAttribute('aria-pressed', String(pinned));

    const icon = button.querySelector('i');
    icon.classList.toggle('fa-solid', pinned);
    icon.classList.toggle('fa-regular', !pinned);

    place(page, card, pinned);
    updatePinnedSection(page);
};

export const togglePin = (button) => {
    const page = button.closest('[data-pin-url]');
    const card = button.closest('.card');
    const pinned = button.getAttribute('aria-pressed') !== 'true';

    const data = new FormData();
    data.set('tool', button.dataset.pinTool);

    applyPinState(button, card, page, pinned);

    const revert = () => applyPinState(button, card, page, !pinned);

    fetch(page.dataset.pinUrl, {
        method: 'post',
        body: data,
    })
        .then(response => {
            if (!response.ok) {
                revert();
            }
        })
        .catch(revert)
    ;
};

export const initializePinnedToolPanels = root => {
    root.querySelectorAll('[data-pin-url]').forEach(page => {
        if (initializedPages.has(page)) {
            return;
        }

        const searchInput = page.querySelector('input[type="search"]');
        initializedPages.add(page);

        let timeout;

        searchInput.addEventListener('input', () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => updatePinnedSection(page), FILTER_SETTLE_DELAY);
        });
    });
};
